import Recoil from 'recoil';
import localStorageEffect from './localStorageEffect';
const last_hospital_id = Recoil.atom({
  key: 'app.last_hospital_id',
  default: null,
  effects: [
    localStorageEffect('_H', null, { initial: false, encryption: true }),
  ]
});
export default last_hospital_id;